<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="链接">
        <el-input
          v-model="formLabelAlign.content"
          style="width:350px"
          placeholder="请输入链接"
          @blur="tiaoInputBlur"
        />
        <div style="margin-top:20px">
          <el-link
            type="primary"
            style="margin-left:10px"
            @click="addidentifittwo"
          >添加获客链接</el-link>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="commitClickuwqw">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { batchupdatedelayedmsgurl } from '@/api/reportExamine.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        content: ''
      },
      tiaoblurIndex: null, // 获取输入框索引值
      addtifit: '{wx_url}',
      iqiyi_promotion_link_no: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(iqiyi_promotion_link_no) {
      console.log('iqiyi_promotion_link_no', iqiyi_promotion_link_no)
      this.iqiyi_promotion_link_no = iqiyi_promotion_link_no
    },
    tiaoInputBlur(e) {
      this.tiaoblurIndex = e.srcElement.selectionStart
    },
    addidentifittwo() {
      if (this.formLabelAlign.content.includes('{wx_url}') || this.formLabelAlign.content.includes('{home_url}')) {
        this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
        return
      }
      this.formLabelAlign.content = this.formLabelAlign.content.slice(0, this.tiaoblurIndex) + this.addtifit + this.formLabelAlign.content.slice(this.tiaoblurIndex)
    },
    commitClickuwqw() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.content == '') {
        this.$message.error('请输入链接')
        return
      }
      batchupdatedelayedmsgurl({
        iqiyi_promotion_link_no: this.iqiyi_promotion_link_no,
        url: this.formLabelAlign.content
      }).then((res) => {
        this.$emit('iodawqq')
        console.log('ok', res)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
